import { createSlice } from "@reduxjs/toolkit";

const currentLanguageSlice = createSlice({
    name: 'currentLanguage',
    initialState:{
        language: "vn",
    },
    reducers:{
        updateCurrentLanguage(state, action) {
            state.language = (action.payload);
          },
    },
    extraReducers:{}
})
export const { updateCurrentLanguage } = currentLanguageSlice.actions 

export default currentLanguageSlice.reducer;